import React from "react"
import { motion } from "framer-motion"
import {
    FileCheck,
    MapPin,
    Briefcase,
    GraduationCap,
    Plane,
    Home,
    ShieldCheck,
    ArrowRight
} from "lucide-react"
import Back from "../../components/common/back/Back"
import { useNavigate } from "react-router-dom"
import "./Services.css"

const servicesData = [
    {
        id: "visa",
        title: "Visa Assistance",
        desc: "Expert guidance for student and travel visas across 15+ countries.",
        icon: <Plane size={32} />,
        path: "/services/visa",
        color: "var(--purple-glow)"
    },
    {
        id: "accommodation",
        title: "Accommodation",
        desc: "Safe and comfortable housing solutions near your university.",
        icon: <Home size={32} />,
        path: "/services/accommodation",
        color: "var(--cyan-glow)"
    },
    {
        id: "career",
        title: "Career Counseling",
        desc: "Psychometric testing and expert advice to find your perfect career path.",
        icon: <Briefcase size={32} />,
        path: "/services/career",
        color: "var(--purple-glow)"
    },
    {
        id: "test-prep",
        title: "Test Preparation",
        desc: "Comprehensive coaching for IELTS, TOEFL, GRE, and GMAT.",
        icon: <GraduationCap size={32} />,
        path: "/services/test-prep",
        color: "var(--cyan-glow)"
    },
    {
        id: "documents",
        title: "Document Verification",
        desc: "Assistance with academic and legal document authentication.",
        icon: <FileCheck size={32} />,
        path: "/services/documents",
        color: "var(--purple-glow)"
    },
    {
        id: "insurance",
        title: "Travel Insurance",
        desc: "Global health and travel coverage for peace of mind abroad.",
        icon: <ShieldCheck size={32} />,
        path: "/services/insurance",
        color: "var(--cyan-glow)"
    }
]

const Services = () => {
    const navigate = useNavigate()

    return (
        <div className="services-page-container">
            <Back title="Our Core Services" />

            <section className="services-grid-section">
                <div className="container">
                    <div className="services-intro">
                        <span className="section-badge">Comprehensive Solutions</span>
                        <h2>Your Bridge to <span className="text-gradient">Global Education</span></h2>
                        <p>From initial counseling to post-arrival support, we provide end-to-end services to make your international education journey seamless.</p>
                    </div>

                    <div className="services-modern-grid">
                        {servicesData.map((service, idx) => (
                            <motion.div
                                key={service.id}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: idx * 0.1 }}
                                whileHover={{ y: -10 }}
                                className="service-modern-card"
                                onClick={() => navigate(service.path)}
                            >
                                <div className="service-card-glow" style={{ background: `radial-gradient(circle at 10% 10%, ${service.color}, transparent 60%)` }}></div>
                                <div className="service-icon-wrapper" style={{ color: service.color, borderColor: `${service.color}33` }}>
                                    {service.icon}
                                </div>
                                <h3>{service.title}</h3>
                                <p>{service.desc}</p>
                                <button className="service-learn-more">
                                    Explore Service <ArrowRight size={16} />
                                </button>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services
